import * as React from 'react'

interface IOption {
  label: string
  value: string
}

interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: IOption[]
}

const Dropdown = (props: IProps) => {
  const { options, value, ...rest } = props

  const hasValueInOptions = options.some(option => option.value === value)

  return (
    <select value={value} {...rest}>
      {!hasValueInOptions && <option selected>-</option>}
      {options.map(option => {
        return (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        )
      })}
    </select>
  )
}

export default Dropdown
